import moment from 'moment'
import commonFunc from './common/commonFunc';
import Enum from '@/enum/enum';
import _ from 'lodash';
import { config } from '@/configs/config';

import filter from './filters/filter';
import { store } from './store/store';
import messageNotification from '@/utils/messageNotification/messageNotification'
import mitt from 'mitt';
const emitter = mitt();
import auth from './auth/auth';

export const installPlugin = (app) => {
    app.config.globalProperties.$moment = moment;
    app.config.globalProperties.$commonFunc = commonFunc;
    app.config.globalProperties.$enum = Enum;
    app.config.globalProperties.$lodash = _;
    app.config.globalProperties.$config = config;
    app.config.globalProperties.$filters = {
        ...filter
    };
    app.config.globalProperties.$stores = store;
    app.config.globalProperties.$messageNotification = messageNotification;
    app.config.globalProperties.$emitter = emitter;
    app.config.globalProperties.$auth = auth;
    app.config.silent = true;
}

export const pluginGlobal = {
    $moment: moment,
    $commonFunc: commonFunc,
    $enum: Enum,
    $lodash: _,
    $filters: {
        ...filter
    },
    $stores: store,
    $messageNotification: messageNotification
}
